Handlebars.registerPartial('partials/common/create_user_new/user_associations/roles/manage/manage', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"manage_link") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0));
},"useData":true}));